import { Routes, Route, Navigate } from "react-router-dom";

import Aviation from "./Aviation";

const aviationRoutes = [
  { routeName: "gsa", component: <Aviation /> },
  { routeName: "air-cargo", component: <Aviation /> },
  { routeName: "chartered", component: <Aviation /> },
  { routeName: "rush-delivery", component: <Aviation /> },
];

const AviationRoutes = () => {
  return (
    <Routes>
      {aviationRoutes.map((route, key) => (
        <Route
          key={key}
          path={route.routeName}
          element={route.component}
        ></Route>
      ))}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AviationRoutes;
